const getWebstormUrl = ({file, line}) => (
    `webstorm://open?file=${file}` + (line != null?`&line=${line}` : "")
);
exports.getWebstormUrl = getWebstormUrl;
